import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Auth API
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  logout: () => api.post('/auth/logout'),
  getMe: () => api.get('/auth/me'),
  googleSession: (sessionId) => api.post('/auth/google-session', { session_id: sessionId }),
};

// Product API
export const productAPI = {
  getAll: (category) => api.get('/products', { params: { category } }),
  getById: (id) => api.get(`/products/${id}`),
};

// Cart API
export const cartAPI = {
  get: () => api.get('/cart'),
  add: (data) => api.post('/cart/add', data),
  update: (data) => api.put('/cart/update', data),
  clear: () => api.delete('/cart/clear'),
};

// Order API
export const orderAPI = {
  create: (data) => api.post('/orders/create', data),
  getAll: () => api.get('/orders'),
  getById: (id) => api.get(`/orders/${id}`),
};

// Checkout API
export const checkoutAPI = {
  createSession: (data) => api.post('/checkout/session', data),
  getStatus: (sessionId) => api.get(`/checkout/status/${sessionId}`),
};

// Upload API
export const uploadAPI = {
  uploadImage: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/upload/image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  getFile: (fileId) => api.get(`/files/${fileId}`, { responseType: 'blob' }),
};

// Scryfall API (external)
export const scryfallAPI = {
  searchCards: async (query) => {
    const response = await axios.get(`https://api.scryfall.com/cards/search`, {
      params: { q: query, unique: 'prints' }
    });
    return response.data;
  },
  getCardByName: async (cardName) => {
    const response = await axios.get(`https://api.scryfall.com/cards/named`, {
      params: { fuzzy: cardName }
    });
    return response.data;
  },
};

export default api;
